import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; 
import styles from "./SearchAssessmentByUser.module.css";

const SearchAssessmentByUser = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAssessments = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          "https://casaahaanahotels.com/new_list_assessments"
        );
        // Ensure we always have an array
        const result = Array.isArray(response.data?.result)
          ? response.data.result
          : [];
        setAssessments(result);

        if (result.length === 0) {
          setError("No assessments found.");
        } else {
          setError("");
        }
      } catch (err) {
        console.error("Error fetching assessments:", err);
        setError("Failed to fetch assessments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAssessments();
  }, []);

  // Filter assessments by driver name
  const filteredAssessments = assessments.filter((assessment) => {
    const firstName = assessment?.driver_details?.FirstName || "";
    const lastName = assessment?.driver_details?.LastName || "";
    const fullName = (firstName + " " + lastName).toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assessments By User</h2>

      <div className={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search by Driver Name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      {loading ? (
        <p className={styles.loading}>Loading...</p>
      ) : error ? (
        <p className={styles.error}>{error}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Email</th>
                <th>Company Name</th>
                <th>Star Score</th>
                <th>Completed Date</th>
                <th>Validity</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {filteredAssessments.map((assessment, idx) => {
                const firstName =
                  assessment.driver_details?.FirstName || "N/A";
                const lastName =
                  assessment.driver_details?.LastName || "N/A";
                const driverName = `${firstName} ${lastName}`;
                const driverEmail =
                  assessment.driver_details?.DriverEmail || "N/A";
                const companyName =
                  assessment.company_details?.companyname || "N/A";
                const starScore = assessment.score || 0;
                const completedDate = new Date(
                  assessment.timestamp
                ).toLocaleDateString("en-US");
                const validityDate = new Date(
                  assessment.validity
                ).toLocaleDateString("en-US");
                const assessmentId = assessment.assessementid;

                return (
                  <tr key={idx}>
                    <td>{driverName}</td>
                    <td>{driverEmail}</td>
                    <td>{companyName}</td>
                    <td>
                      <img
                        src={`https://starbehaviors.com/uploadimage/${starScore}.png`}
                        alt={`Score: ${starScore}`}
                        className={styles.scoreImage}
                      />
                    </td>
                    <td>{completedDate}</td>
                    <td>{validityDate}</td>
                    <td>
                      <button
                        className={styles.viewButton}
                        onClick={() =>
                          navigate(
                            `/admin/search-assessments/${assessmentId}`
                          )
                        }
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SearchAssessmentByUser;
